import { defineMessages } from 'react-intl-next';

export default defineMessages({
	successMessage: {
		id: 'ai-mate.inline-chat-input.success-view.message',
		defaultMessage: 'No improvements, nice work.',
		description:
			'Message displayed when no changes were made to the generated content from AI mate',
	},
});
